exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.search-card[data-v-18331c02] {\n  margin-bottom: 20px;\n}\n.table-card[data-v-18331c02] {\n  margin-top: 0;\n}\n", ""]);

// exports
